import { KeyboardKeyType, type KeyboardKeySetting } from './keyboard-types';

const KeyType = KeyboardKeyType;
/** 键值配置常量 */
const blankKey = { key: KeyType.Blank, className: 'transparent' }; // 空白键
const deleteKey = { key: KeyType.Delete, className: 'delete-btn' }; // 删除键
const confirmKey = { key: KeyType.Confirm, className: 'confirm-btn' }; // 确认键
const zeroKey = { key: '0', className: 'zero' }; // 0键
const decimalZeroKey = { key: '0', className: 'decimal-zero' }; // 小数模式下的0键

/**
 * 键盘各模式下的键位配置
 * 考虑到键盘可能分为2栏，所以配置采取二维数组的形式
 */
const keyboardSetting = {
  default: {
    normal: ['1', '2', '3', '4', '5', '6', '7', '8', '9', blankKey, '0', deleteKey], // 纯数字输入
    decimal: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', deleteKey], // 小数输入
  },
  confirm: {
    normal: [['1', '2', '3',  '4', '5', '6', '7', '8', '9', zeroKey], [KeyType.Delete, confirmKey]], // 带确认按钮的数字输入
    decimal: [['1', '2', '3', '4', '5', '6', '7', '8', '9', decimalZeroKey, '.'], [KeyType.Delete, confirmKey]], // 带确认按钮的小数输入
  },
};

/**
 * 获取默认类型键盘配置
 * @param decimal 是否为小数键盘
 * @returns 默认键盘设置
 */
export function getDefaultKeyboardSetting(decimal = false):KeyboardKeySetting[] {
  const setting = keyboardSetting.default[decimal ? 'decimal' : 'normal'];
  return setting.map(item => (typeof item === 'string' ? { key: item } : item));
}

/**
 * 获取带确认按钮类型键盘配置
 * @param decimal 是否为小数键盘
 * @returns 带确认按钮的键盘设置
 */
export function getConfirmKeyboardSetting(decimal = false):KeyboardKeySetting[][] {
  const setting = keyboardSetting.confirm[decimal ? 'decimal' : 'normal'];
  return setting.map(row => row.map(item => (typeof item === 'string' ? { key: item } : item)));
}

/**
 * 将键位分组
 * @param keys 键位配置
 * @param splitCount 分组每组个数
 * @returns 分组后的键位配置
 */
export function splitKeyboardKeys(keys: KeyboardKeySetting[], splitCount = 3): KeyboardKeySetting[][] {
  const result: KeyboardKeySetting[][] = [];
  for (let i = 0; i < keys.length; i += splitCount) {
    result.push(keys.slice(i, i + splitCount));
  }
  return result;
}
